import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/fonts/Hyundai/HyundaiSansTextKRRegular.ttf';
import './assets/fonts/Hyundai/HyundaiSansHeadKRMedium.ttf';
import './index.css';
// import "./build.css";  for production
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
